import { formatPrice } from '@scripts/frontend/libs/utils/format-price'

interface ProductPriceProps {
  price: number
  regularPrice: number
  salePrice: number
}

export function ProductPrice({
  price,
  regularPrice,
  salePrice,
}: Readonly<ProductPriceProps>) {
  const isSale = salePrice > 0 && salePrice < regularPrice

  const calculatePercentage = (price: number, salePrice: number) => {
    return Math.round(((price - salePrice) / price) * 100)
  }

  if (isSale) {
    return (
      <div className="mb-6 flex items-center justify-between gap-4">
        <span className="text-lg font-medium text-primary">
          {formatPrice(regularPrice)}
        </span>
        <div className="flex gap-3 bg-primary px-3 py-1 text-[1.08333rem] font-normal text-white">
          <span>-{calculatePercentage(regularPrice, salePrice)}%</span>
          <span>{formatPrice(price)}</span>
        </div>
      </div>
    )
  }

  return (
    <div className="mb-6 flex items-center justify-between gap-4">
      <span className="text-lg font-medium text-primary">
        {formatPrice(price)}
      </span>
    </div>
  )
}

export default ProductPrice
